import { styled, Box } from '@mui/material';

export const StyledBox = styled(Box)(() => ({
  '& .MuiFormControl-root': {
    marginBottom: '4px',
  },
}));
